import { ReactNode } from 'react'

interface SettingsSectionProps {
  title: string
  description?: string
  children: ReactNode
}

function SettingsSection({ title, description, children }: SettingsSectionProps) {
  return (
    <div className="settings-section">
      <div className="settings-section-header">
        <h2>{title}</h2>
        {description && <p className="settings-section-description">{description}</p>}
      </div>
      <div className="settings-section-content">
        {children}
      </div>
    </div>
  )
}

export default SettingsSection
